import { c as _c } from "react/compiler-runtime";
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useWebsites } from 'modules/websites/hooks/use-websites';
import { NeutralButton, Tooltip } from '@systemeio/ui';
import TransLoco from 'shared/components/trans-loco';
interface DomainWebsiteLoginPageButtonProps {
  domainId: number;
  domainName: string;
  isWhiteLabelDomain: boolean;
}
export const DomainWebsiteLoginPageButton = t0 => {
  const $ = _c(16);
  const {
    domainId,
    domainName,
    isWhiteLabelDomain
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    websites,
    isFetching
  } = useWebsites();
  let t1;
  if ($[0] !== domainId || $[1] !== websites) {
    t1 = websites && websites.items.find(website => website.domainId === domainId);
    $[0] = domainId;
    $[1] = websites;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const website_0 = t1;
  let t2;
  if ($[3] !== domainName || $[4] !== isWhiteLabelDomain || $[5] !== t || $[6] !== website_0) {
    t2 = isWhiteLabelDomain ? t("dashboard.settings.custom_domains.cant_edit_page_warning") : website_0 && website_0.templateId ? t("dashboard.settings.custom_domains.can_edit_website_login_page") : <TransLoco t={t} i18nKey="dashboard.settings.custom_domains.cant_edit_website_login_page" values={{
      domainName
    }} components={{
      a: <a target="_blank" rel="noreferrer" href={`https://${domainName}/login`} className="primary-link" />
    }} />;
    $[3] = domainName;
    $[4] = isWhiteLabelDomain;
    $[5] = t;
    $[6] = website_0;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const labelTooltip = t2;
  let t3;
  if ($[8] !== t) {
    t3 = t("dashboard.settings.custom_domains.login_page_edit");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isFetching || $[11] !== t3) {
    t4 = <NeutralButton disabled={true} isFetching={isFetching}>{t3}</NeutralButton>;
    $[10] = isFetching;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== labelTooltip || $[14] !== t4) {
    t5 = <Tooltip popoverClassName="!max-w-[300px]" label={labelTooltip} stayOnHover={true}>{t4}</Tooltip>;
    $[13] = labelTooltip;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};